(function () {
  "use strict";

  var giftsSelector = ".kaching-bundles__progressive-gifts__gifts";
  var giftSelector = ".kaching-bundles__progressive-gifts__gift";
  var bundleDealBarIds = {
    buyOne: "IE8J",
    buyTwo: "4K_F",
    buyThree: "30-j",
  };
  var bundleGalleryImages = {
    "4K_F":
      "https://cdn.shopify.com/s/files/1/0644/0681/4763/files/image_23.webp",
    "30-j":
      "https://cdn.shopify.com/s/files/1/0644/0681/4763/files/Fineroot_Product_Page_final_3_bottle.webp",
  };
  var mainGalleryImage;
  var mainGalleryImageOriginal;

  // The first three images are read from the rendered Kaching gifts.
  // These are the two images Kaching omits from the locked-card markup.
  var lockedGiftImages = [
    "https://www.fineroot.co/cdn/shop/files/hf_20260728_112731_c112653d-56aa-4d4b-b7c6-6fb71929d5cd.png?height=200&v=1785498096",
    "https://www.fineroot.co/cdn/shop/files/mystery-box-1.png?height=200&v=1778240532",
  ];

  var giftMeta = [
    {
      productId: 7917160923179,
      renderedByKaching: true,
      name: "FineRoot Anti-inflammatory Food Guide eBook",
      freeText: "FREE eBook",
      description: "Anti-inflammatory nutrition guide",
      showInCallout: false,
    },
    {
      productId: 7851276697643,
      renderedByKaching: true,
      name: "Pill Organiser",
      description: "Keep your supplements organized",
    },
    {
      name: "Shipping",
      freeText: "FREE Shipping",
      description: "Free shipping on your order",
      showInCallout: false,
    },
    {
      productId: 8027957461035,
      renderedByKaching: true,
      name: "On-the-go Pill Case",
      description: "Travel-ready supplement storage",
      image:
        "https://www.fineroot.co/cdn/shop/files/hf_20260728_112731_c112653d-56aa-4d4b-b7c6-6fb71929d5cd.png?height=200&v=1785498096",
    },
  ];

  var giftImages = [];
  var giftProducts = window.finerootGiftProducts || {};
  var renderedGiftProductIds = [];
  var giftProductsRequestStarted = false;

  function getGiftProduct(meta) {
    return giftProducts[String(meta.productId)] || {};
  }

  function getGiftName(meta) {
    return getGiftProduct(meta).offerTitle || meta.name;
  }

  function getFreeGiftLabel(meta) {
    var name = getGiftName(meta);
    return "FREE " + name.replace(/^(?:FREE\s+)+/i, "").trim();
  }

  function getGiftDescription(meta) {
    return getGiftProduct(meta).offerDescription || meta.description;
  }

  function getGiftComparePrice(meta) {
    var product = getGiftProduct(meta);
    return product.offerComparePrice || product.price || "";
  }

  function getGiftMeta(index) {
    var productId = renderedGiftProductIds[index];
    if (!productId) return;

    return giftMeta.find(function (meta) {
      return meta.productId === productId;
    });
  }

  function loadRenderedGiftProductIds() {
    if (giftProductsRequestStarted || !window.kachingBundlesApi?.fetchDeals)
      return;

    giftProductsRequestStarted = true;
    window.kachingBundlesApi
      .fetchDeals()
      .then(function (deals) {
        var configuredIds = giftMeta
          .filter(function (meta) {
            return meta.renderedByKaching;
          })
          .map(function (meta) {
            return meta.productId;
          });
        var matchingGifts;

        deals.some(function (deal) {
          return deal.dealBars.some(function (bar) {
            var freeGifts = bar.freeGifts || [];
            var productIds = freeGifts.map(function (gift) {
              return gift.productId;
            });
            var matches = configuredIds.every(function (productId) {
              return productIds.indexOf(productId) !== -1;
            });
            if (matches) matchingGifts = freeGifts;
            return matches;
          });
        });

        if (!matchingGifts)
          throw new Error("FineRoot gift product IDs do not match Kaching");

        renderedGiftProductIds = configuredIds.filter(function (productId) {
          return matchingGifts.some(function (gift) {
            return gift.productId === productId;
          });
        });
        applyLockedGiftImages();
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  function getGiftImages(gifts) {
    Array.prototype.forEach.call(gifts, function (gift, index) {
      var image = gift.querySelector("img");
      if (image) giftImages[index] = image.currentSrc || image.src;
    });

    // Preserve the images rendered before Kaching rerenders the locked cards.
    giftImages[3] = giftImages[3] || lockedGiftImages[0];
    giftImages[4] = giftImages[4] || lockedGiftImages[1];
    return giftImages;
  }

  function applyLockedGiftImages() {
    var root = document.querySelector(giftsSelector);
    if (!root) return false;

    if (!root.querySelector(":scope > .ggd-label")) {
      var giftLabel = document.createElement("div");
      giftLabel.className = "ggd-label";
      giftLabel.textContent = "GIFTS UNLOCKED";
      root.appendChild(giftLabel);
    }

    var gifts = root.querySelectorAll(":scope > " + giftSelector);
    if (!gifts.length) return false;

    var images = getGiftImages(gifts);

    Array.prototype.forEach.call(gifts, function (gift, index) {
      var meta = getGiftMeta(index);
      if (!gift.querySelector(".fineroot-gift-meta")) {
        if (meta) {
          var metaElement = document.createElement("div");
          metaElement.className = "fineroot-gift-meta";

          var price = document.createElement("span");
          price.className = "fineroot-gift-meta__price";
          var comparePrice = getGiftComparePrice(meta);
          price.textContent = comparePrice || "\u00a0";
          if (!comparePrice)
            price.classList.add("fineroot-gift-meta__price--empty");
          metaElement.appendChild(price);

          var free = document.createElement("span");
          free.className = "fineroot-gift-meta__free";
          free.textContent = getFreeGiftLabel(meta);
          metaElement.appendChild(free);
          var content = gift.querySelector(
            ".kaching-bundles__progressive-gifts__gift__content",
          );
          if (content) content.appendChild(metaElement);
        }
      }

      if (
        !gift.classList.contains(
          "kaching-bundles__progressive-gifts__gift--locked",
        )
      )
        return;
      var lockedImage = meta?.image || images[index];
      if (!lockedImage) return;

      var wrapper = gift.querySelector(
        ".kaching-bundles__progressive-gifts__gift__image-wrapper",
      );
      if (!wrapper || wrapper.querySelector(".fineroot-locked-gift-image"))
        return;

      var image = document.createElement("img");
      image.className = "fineroot-locked-gift-image";
      image.alt = "";
      image.src = lockedImage;
      wrapper.appendChild(image);

      var label = document.createElement("span");
      label.className = "fineroot-locked-gift-label";
      label.textContent = "Locked";
      gift.appendChild(label);
    });

    return true;
  }

  function getOfferGiftCount(bar) {
    var dealBarId = bar.getAttribute("data-deal-bar-id");
    if (dealBarId === bundleDealBarIds.buyThree) return 5;
    if (dealBarId === bundleDealBarIds.buyTwo) return 3;
    if (dealBarId === bundleDealBarIds.buyOne) return 1;
    return 0;
  }

  function createOfferGiftCallout(meta) {
    var callout = document.createElement("div");
    callout.className = "pdp-main__offer-gift offer-gift-callout";

    var icon = document.createElement("span");
    icon.className = "fineroot-offer-gift__icon";
    icon.innerHTML =
      '<svg width="14" height="11" viewBox="0 0 14 11" fill="none" aria-hidden="true"><path d="M1.5 5.5L5.5 9.5L12.5 1.5" stroke="#009370" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    callout.appendChild(icon);

    var copy = document.createElement("div");
    var title = document.createElement("div");
    title.className = "fineroot-offer-gift__title";
    title.textContent =
      getFreeGiftLabel(meta) + " (" + getGiftComparePrice(meta) + " Value)";
    copy.appendChild(title);

    var description = document.createElement("div");
    description.className = "fineroot-offer-gift__description";
    description.textContent = getGiftDescription(meta);
    copy.appendChild(description);
    callout.appendChild(copy);

    return callout;
  }

  function createOfferValueCallout() {
    var callout = document.createElement("div");
    callout.className =
      "pdp-main__offer-gift offer-gift-callout fineroot-offer-value-callout";

    var icon = document.createElement("span");
    icon.className = "fineroot-offer-value-callout__icon";
    icon.innerHTML =
      '<svg width="10" height="8" viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 5L4.5 8.5L11 1" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    callout.appendChild(icon);

    var copy = document.createElement("div");
    var headline = document.createElement("div");
    headline.className = "fineroot-offer-value-callout__text";
    headline.textContent =
      "2x Turmeric Capsules + 1x Triple Complex Magnesium ($150 Value)";
    copy.appendChild(headline);

    var description = document.createElement("div");
    description.className = "fineroot-offer-value-callout__description";
    description.textContent = "Daily Joint Support & Muscle Relaxation";
    copy.appendChild(description);
    callout.appendChild(copy);

    return callout;
  }

  function createPlusFreeGiftsDivider() {
    var divider = document.createElement("div");
    divider.className =
      "offer-gift-callout offer-gift-divider fineroot-plus-free-gifts";

    var leftLine = document.createElement("div");
    leftLine.className = "offer-gift-divider__line";
    divider.appendChild(leftLine);

    var text = document.createElement("span");
    text.className = "fineroot-plus-free-gifts__text";
    text.textContent = "PLUS FREE GIFTS";
    divider.appendChild(text);

    var rightLine = document.createElement("div");
    rightLine.className = "offer-gift-divider__line";
    divider.appendChild(rightLine);

    return divider;
  }

  function applyOfferGiftCallouts() {
    var bars = document.querySelectorAll(".kaching-bundles__bar");
    if (!bars.length) return false;

    Array.prototype.forEach.call(bars, function (bar) {
      if (bar.querySelector(".fineroot-offer-gifts")) return;

      var titleElement = bar.querySelector(".kaching-bundles__bar-title");
      var wrapper = bar.querySelector(".kaching-bundles__bar-wrapper");
      if (!titleElement || !wrapper) return;

      var giftCount = getOfferGiftCount(bar);
      if (!giftCount) return;

      var calloutGifts = giftMeta.slice(0, giftCount).filter(function (meta) {
        return meta.showInCallout !== false;
      });
      if (!calloutGifts.length) return;

      var gifts = document.createElement("div");
      gifts.className = "fineroot-offer-gifts";

      var divider = document.createElement("div");
      divider.className = "offer-gift-callout offer-gift-divider";
      var line = document.createElement("div");
      line.className = "offer-gift-divider__line";
      divider.appendChild(line);
      gifts.appendChild(divider);

      if (bar.getAttribute("data-deal-bar-id") === bundleDealBarIds.buyThree) {
        gifts.appendChild(createOfferValueCallout());
        gifts.appendChild(createPlusFreeGiftsDivider());
      }

      calloutGifts.forEach(function (meta) {
        gifts.appendChild(createOfferGiftCallout(meta));
      });

      wrapper.appendChild(gifts);
    });

    return true;
  }

  function getMainGalleryImage() {
    return document.querySelector(
      ".product__media-list .product__media-item:first-child img.image-magnify-none",
    );
  }

  function restoreMainGalleryImage() {
    if (!mainGalleryImage || !mainGalleryImageOriginal) return;

    if (mainGalleryImageOriginal.srcset === null) {
      mainGalleryImage.removeAttribute("srcset");
    } else {
      mainGalleryImage.setAttribute("srcset", mainGalleryImageOriginal.srcset);
    }
    mainGalleryImage.setAttribute("src", mainGalleryImageOriginal.src);
  }

  function updateMainGalleryImage() {
    var image = getMainGalleryImage();
    if (!image) return false;

    if (image !== mainGalleryImage) {
      mainGalleryImage = image;
      if (!mainGalleryImageOriginal) {
        mainGalleryImageOriginal = {
          src: image.getAttribute("src"),
          srcset: image.getAttribute("srcset"),
        };
      }
    }

    var selectedBar = document.querySelector(".kaching-bundles__bar--selected");
    var selectedDealBarId = selectedBar?.getAttribute("data-deal-bar-id");
    var subscriptionCheckbox = document.querySelector(
      '.kaching-bundles__subscriptions [role="checkbox"]',
    );
    var selectedGalleryImage = bundleGalleryImages[selectedDealBarId];
    var shouldShowBundleImage =
      selectedGalleryImage &&
      subscriptionCheckbox?.getAttribute("aria-checked") === "true";

    if (shouldShowBundleImage) {
      image.removeAttribute("srcset");
      image.setAttribute("src", selectedGalleryImage);
    } else {
      restoreMainGalleryImage();
    }

    return true;
  }

  function init() {
    loadRenderedGiftProductIds();
    applyLockedGiftImages();
    applyOfferGiftCallouts();
    updateMainGalleryImage();

    var observer = new MutationObserver(function (mutations) {
      var hasChildChanges = mutations.some(function (mutation) {
        return mutation.type === "childList";
      });
      var hasBundleStateChanges = mutations.some(function (mutation) {
        return (
          mutation.type === "attributes" &&
          mutation.target.matches(
            '.kaching-bundles__bar, .kaching-bundles__subscriptions [role="checkbox"]',
          )
        );
      });

      if (hasChildChanges) {
        loadRenderedGiftProductIds();
        applyLockedGiftImages();
        applyOfferGiftCallouts();
      }
      if (hasChildChanges || hasBundleStateChanges) updateMainGalleryImage();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["aria-checked", "class"],
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
